import { FieldService, IGetFieldsRequest, IField, IServerSideGetRowsParams } from '@samc/centricity-core';
import { IPaginatedList } from '@samc/common';

export interface IGetDueDiligenceFieldsRequest extends IGetFieldsRequest {
  reviewTypeId: string;
}

export class DueDiligenceFieldService extends FieldService {
  public reviewTypeId = '';

  public getFields(req?: IGetDueDiligenceFieldsRequest, params?: IServerSideGetRowsParams): Promise<IPaginatedList<IField>> {
    if (req === undefined) {
      req = { reviewTypeId: this.reviewTypeId };
    } else {
      req.reviewTypeId = this.reviewTypeId;
    }
    return super.getFields(req, params);
  }
}